import Image from '@next/image';

import classNames from 'classnames';

import { PackageContent } from 'types/models/PackageContent';

import classes from './PackageContent.module.scss';

type Props = {
  packageContent: PackageContent[];
  className?: string;
};

const PackageContent = ({ className, packageContent }: Props): JSX.Element => (
  <div className={classNames(classes.wrapper, className)}>
    <div className={classes.contentWrapper}>
      {packageContent.map(({ name, file }) => (
        <div className={classes.itemWrapper} key={name}>
          <Image
            layout="fill"
            objectFit="contain"
            alt={name}
            className={classes.icon}
            resolveConfig={{
              preset: 'svg',
              description: name,
              extension: file?.extension,
              name: file?.basename,
              width: file?.width,
              height: file?.height,
              productName: name,
            }}
          />
          <p className={classes.name}>{name}</p>
        </div>
      ))}
    </div>
  </div>
);

export default PackageContent;
